module.exports = __webpack_public_path__ + "img/motor.a12a9178.jpg";